export default __webpack_public_path__ + "static/media/noMessagePic.fb97c923.png";